<template>
  <div class="typer">
    <span v-for="(char, index) in currentChars" :key="index">{{char}}</span>
    <span class="typer-caret" :class="caretClasses">|</span>
  </div>
</template>
<script>
const STATE = {
  IDLE: "idle",
  TYPING: "typing",
  COMPLETE: "complete"
};
export default {
  props: {
    text: {
      default: ""
    },
    showCaret: {
      default: true
    },
    animateCaret: {
      default: true
    },
    remainIdle: {
      default: true
    },
    beginTypingDelay: {
      default: 0
    },
    typeCharDelay: {
      default: 500
    },
    autoStart: {
      default: true
    }
  },
  data() {
    return {
      state: STATE.IDLE,
      textArr: [],
      currentTextIndex: 0,
      typingInterval: null
    };
  },
  computed: {
    currentChars() {
      return this.textArr.slice(0, this.currentTextIndex);
    },
    isTypingComplete() {
      return this.currentTextIndex >= this.textArrLength;
    },
    textArrLength() {
      return this.textArr.length;
    },
    renderCaret() {
      if (!this.showCaret) return false;
      if (this.isTypingComplete && !this.remainIdle) return false;
      return true;
    },
    caretClasses() {
      return {
        "is-hidden": !this.renderCaret,
        blink: this.animateCaret && this.state == STATE.IDLE
      };
    }
  },
  mounted() {
    this.textArr = Array.from(this.text);
    if (this.autoStart) {
      this.start();
    }
  },
  methods: {
    start() {
      setTimeout(() => {
        this.typingInterval = setInterval(this.typeChar, this.typeCharDelay);
      }, this.beginTypingDelay);
    },
    stop() {
      clearInterval(this.typingInterval);
      this.typingInterval = null;
      this.state = STATE.IDLE;
    },
    typeChar() {
      this.state = STATE.TYPING;
      this.currentTextIndex = Math.min(
        this.currentTextIndex + 1,
        this.textArrLength
      );

      if (this.isTypingComplete) {
        if (this.remainIdle) {
          this.state = STATE.IDLE;
        } else {
          this.state = STATE.COMPLETE;
        }
        clearInterval(this.typingInterval);
        this.$emit("typing-complete");
      }
    }
  }
};
</script>

<style lang="scss">
.typer {
  display: inline;
}

@keyframes blink {
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.typer-caret {
  &:empty:before {
    content: "\200b";
  }

  &.blink {
    animation: blink 1s step-start 0s infinite;
  }
}
</style>
